<script setup lang="ts">
const props = defineProps<{
	token?: string
	email?: string
	status?: string
}>()

const form = useForm({
	method: 'POST',
	url: route('password.update'),
	fields: {
		email: props.email || '',
		password: '',
		password_confirmation: '',
		token: props.token,
	},
})

onMounted(() => {
	if (!props.token) {
		router.get(route('login'))
	}
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/auth.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<message-wrapper>
		<message-success v-if="status" class="mb-2">
			{{ status }}
		</message-success>
	</message-wrapper>

	<form class="space-y-5" @submit.prevent="form.submit">
		<form-input-wrapper :label="t('app.email')" for="email" :errors="form.errors.email">
			<form-input-text
				id="email"
				v-model="form.fields.email"
				type="email"
				required
				readonly
				autocomplete="username"
			/>
		</form-input-wrapper>

		<form-input-wrapper :label="t('app.password')" for="password" :errors="form.errors.password">
			<form-input-text
				id="password"
				v-model="form.fields.password"
				type="password"
				required
				autofocus
				autocomplete="new-password"
			/>
		</form-input-wrapper>

		<form-input-wrapper :label="t('app.password_confirmation')" for="password_confirmation" :errors="form.errors.password_confirmation">
			<form-input-text
				id="password_confirmation"
				v-model="form.fields.password_confirmation"
				type="password"
				required
				autocomplete="new-password"
			/>
		</form-input-wrapper>

		<div class="flex">
			<button-base type="submit" :loading="form.processing" class="ml-auto">
				{{ t('app.reset_password') }}
			</button-base>
		</div>
	</form>
</template>
